import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../../Endpoints/Endpoints'; // Adjust the path based on your project structure

const UpdateCard = () => {
  const [cardData, setCardData] = useState({
    cardname: '',
    cardgroup: '',
    grpsymbol: '',
    gamename: '',
    gamecategory: '',
    complexity: '',
    goal: '',
    age: '',
    difflevel: '',
    implementation: '',
  });

  const navigate = useNavigate();
  const { cardid } = useParams();

  useEffect(() => {
   
      fetchCardData();
  }, []);

  const fetchCardData = () => {
    axios({
      url: API.GET_CARD_BYID(cardid), 
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        setCardData(res.data[0]); 
      })
      .catch((err) => {
        alert('Error fetching card data: ' + err);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCardData({ ...cardData, [name]: value });
  };

  const updateCard = (e) => {
    e.preventDefault();
    axios.put(API.PUT_CARD_API(cardid), cardData, {
      headers: {
          'Content-Type': 'application/json',
      },
  })
  .then((res) => {
      alert('Card updated successfully');
      navigate('/cardtable');
  })
  .catch((err) => {
      console.error('Error updating card group:', err);
      alert('Error updating card group: ' + err.message);
  });
  };

  const goBack = () => {
    navigate('/cardtable');
  };

  return (
<div className='bg-[#B5B5B5] h-auto pb-20 pt-10'>
      <div className='max-w-4xl mx-auto pt-10'>
        <form onSubmit={updateCard} className='bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4'>
          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Card Name</label>
            <input
              type='text'
              name='cardname'
              value={cardData.cardname}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Card Group</label>
            <input
              type='text'
              name='cardgroup'
              value={cardData.cardgroup}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Group Symbol</label>
            <input
              type='text'
              name='grpsymbol'
              value={cardData.grpsymbol}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Game Name</label>
            <input
              type='text'
              name='gamename'
              value={cardData.gamename}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Game Category</label>
            <textarea
              name='gamecategory'
              value={cardData.gamecategory}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Complexity</label>
            <textarea
              name='complexity'
              value={cardData.complexity}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Goal</label>
            <textarea
              name='goal'
              value={cardData.goal}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Age Group</label>
            <textarea
              name='age'
              value={cardData.age}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Difficulty Level</label>
            <textarea
              name='difflevel'
              value={cardData.difflevel}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Implementation</label>
            <textarea
              name='implementation'
              value={cardData.implementation}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='flex items-center justify-between'>
            <button
              type='submit'
              className='bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Update
            </button>
            <button
              type='button'
              onClick={goBack}
              className='bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateCard;
